import { PERMISSIONS } from '@conversed/shared/src/central/constants/permissions';
import { z } from 'zod';
import { createRESTContract } from '../../index';
import {
  ConversationKeywordSchema,
  KeywordBodySchema,
  UpdateConversationKeywordsResponseSchema,
  UpdateConversationKeywordsSchema,
} from './conversation-keywords.schema';

export const conversationKeywordsContract = createRESTContract({
  getConversationKeywords: {
    method: 'GET',
    path: '/conversation-keywords',
    permissions: [PERMISSIONS.CONVERSATION_KEYWORDS.CONVERSATION_KEYWORDS_LIST],
    response: z.array(ConversationKeywordSchema),
  },
  updateConversationKeywords: {
    method: 'PUT',
    path: '/conversation-keywords/:conversationId',
    permissions: [PERMISSIONS.TRAINER_AI.TRAINER_AI_EDIT],
    body: UpdateConversationKeywordsSchema,
    response: UpdateConversationKeywordsResponseSchema,
  },
  createKeyword: {
    method: 'POST',
    path: '/conversation-keywords/keyword',
    permissions: [
      PERMISSIONS.CONVERSATION_KEYWORDS.CONVERSATION_KEYWORDS_CREATE,
    ],
    body: KeywordBodySchema,
    response: ConversationKeywordSchema,
  },
  editKeyword: {
    method: 'PUT',
    path: '/conversation-keywords/keyword/:id',
    permissions: [PERMISSIONS.CONVERSATION_KEYWORDS.CONVERSATION_KEYWORDS_EDIT],
    body: KeywordBodySchema,
    response: ConversationKeywordSchema,
  },
  deleteKeyword: {
    method: 'DELETE',
    path: '/conversation-keywords/keyword/:id',
    permissions: [
      PERMISSIONS.CONVERSATION_KEYWORDS.CONVERSATION_KEYWORDS_DELETE,
    ],
    body: z.void(),
    response: z.void(),
  },
});
